import { render, staticRenderFns } from "./RuleBulkDelete.vue?vue&type=template&id=4f4cefa0&scoped=true"
import script from "./RuleBulkDelete.vue?vue&type=script&lang=js"
export * from "./RuleBulkDelete.vue?vue&type=script&lang=js"
import style0 from "./RuleBulkDelete.vue?vue&type=style&index=0&id=4f4cefa0&prod&lang=css"
import style1 from "./RuleBulkDelete.vue?vue&type=style&index=1&id=4f4cefa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4cefa0",
  null
  
)

export default component.exports